const localState = {
    list: null,
    tool: {
        name: '',
        is_scooter: false,
    },
}

const mutations = {
    setState: (state, {
        key,
        data,
    }) => {
        state[key] = data
    },
}

const actions = {
    async fetch({
        commit,
    }) {
        const response = await this.$api.tools.fetch()

        commit('setState', {
            key: 'list',
            data: response.data.data || [],
        })
    },
    async add({
        state,
    }) {
        return await this.$api.tools.add(state.tool)
    },
    async update({ state }, id) {
        return await this.$api.tools.update(id, state.tool)
    },
    async remove(_, id) {
        return await this.$api.tools.remove(id)
    },
}
const getters = {
    list: (state) => state.list,
    tool: (state) => state.tool,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
